// extracted by mini-css-extract-plugin
export default {"routineblock":"AV","container":"BV","carousel":"CV","routine":"EV","heading":"FV","routinelist":"GV","routineitem":"HV","routineimg":"IV","routinedesc":"JV","routinename":"KV","routinetext":"LV","carouselwrap":"MV"};
    if(module.hot) {
      // 1721922365826
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  